import styled from 'styled-components';

export default styled.div`

  @media all and (max-width: ${(props) => props.theme.breakingpoints.lg}) {
    padding-top: 1rem;
    padding-bottom: 2rem;
  }
`;
